exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{height:100%}.login-page{display:flex;flex-direction:row;height:100%;background-color:#eee}.login-form{width:480px;margin:auto}form{width:100%;background:#fff;border-radius:4px;padding:20px}form button,form input{width:100%;margin:5px 0}.logo-filekom{width:250px}.btnlogin{padding-top:.8rem;padding-bottom:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57e1ca22","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Login.vue
// module id = 207
// module chunks = 58